import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FadeUpAnimation from '../../components/base/FadeUpAnimation';
import { useSEO, getSiteUrl } from '../../utils/seo';

const HomePage = () => {
  useSEO({
    title: '2b LLC — 静かな伴走、そっと前へ | 生成AI・政策・地域活性化支援',
    description: '変わりたいのに動けない、その背中をそっと押したいー\n2b LLCは誰かの想いを形にするために寄り添い、あるべき姿に向けた最初の一歩を支援します。',
    keywords: '2b LLC,生成AI,AIコンサルティング,政策支援,地域活性化',
    canonical: getSiteUrl('/'),
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          name: '合同会社2b',
          alternateName: '2b LLC',
          url: getSiteUrl('/'),
          logo: 'https://static.readdy.ai/image/721199a06948bc0907bde1e591c4b4e9/191bb64e22d504c48b73a6bcbfddf67c.png',
          description: '静かな伴走で誰かの想いを形にする会社',
          foundingDate: '2025-02-06',
          address: {
            '@type': 'PostalAddress',
            addressLocality: '世田谷区',
            addressRegion: '東京都',
            addressCountry: 'JP'
          },
          email: 'tobe26.2b@gmail.com',
          founder: {
            '@type': 'Person',
            name: '田崎 陽介'
          },
          sameAs: []
        },
        {
          '@type': 'WebSite',
          '@id': getSiteUrl('/#website'),
          url: getSiteUrl('/'),
          name: '2b LLC',
          description: '静かな伴走、そっと前へ',
          publisher: {
            '@id': getSiteUrl('/#organization')
          }
        }
      ]
    }
  });

  return (
    <div className="min-h-screen bg-[#F6F3EB]">
      <Header />
      
      {/* ① ヒーローセクション */}
      <section
        className="py-20 bg-[#F6F3EB] relative overflow-hidden"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/e2b7ee5b3a9942b5096b53c830eefd2f.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-[#F6F3EB]/70"></div>
        <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
          <div className="text-center max-w-4xl mx-auto relative z-10">
            <FadeUpAnimation duration={1400}>
              <img
                src="https://static.readdy.ai/image/721199a06948bc0907bde1e591c4b4e9/191bb64e22d504c48b73a6bcbfddf67c.png"
                alt="2b LLC"
                className="w-[480px] h-auto mx-auto mb-12 object-contain"
              />
            </FadeUpAnimation>

            <FadeUpAnimation delay={200} duration={1400}>
              <h1
                className="text-4xl md:text-5xl lg:text-6xl font-medium text-[#4A4A48] mb-8 leading-relaxed"
                style={{ fontFamily: 'Zen Kaku Gothic Soft, sans-serif' }}
              >
                静かな伴走。
                <br />
                そっと、前へ。
              </h1>
            </FadeUpAnimation>

            <FadeUpAnimation delay={400} duration={1400}>
              <p
                className="text-[22px] text-[#4A4A48] leading-[1.8] font-normal mt-8"
                style={{ fontFamily: 'Zen Kaku Gothic Soft, sans-serif' }}
              >
                ひとの想いが形になる、<br className="md:hidden" />
                その瞬間に立ち会いたい。
              </p>
            </FadeUpAnimation>
          </div>
        </div>
      </section>

      {/* Lead Text Section */}
      <section className="py-32 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <FadeUpAnimation delay={600}>
            <p className="text-lg md:text-xl text-[#4A4A48] leading-[1.8] font-medium" style={{ fontFamily: 'Zen Kaku Gothic Soft, sans-serif' }}>
              誰かの想いが、形になる。<br />
              その過程を、静かに支える会社です。
            </p>
          </FadeUpAnimation>
        </div>
      </section>

      {/* ③ ミッションセクション */}
      <section className="py-24 bg-[#F6F3EB]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-white rounded-3xl p-16 md:p-20 shadow-sm">
            <div className="space-y-16">
              <FadeUpAnimation delay={200}>
                <div className="text-center">
                  <p
                    className="text-xs md:text-[24px] text-[#4A4A48] leading-[2.0] md:leading-[2.2] font-light"
                    style={{ fontFamily: 'Zen Kaku Gothic Soft, sans-serif' }}
                  >
                    変わりたいのに、動けない。<br />
                    そんな誰かの背中を、<br className="md:hidden" />静かに押せる存在でありたい。
                  </p>
                </div>
              </FadeUpAnimation>

              <div className="w-16 h-px bg-[#D7D5D0] mx-auto"></div>

              <FadeUpAnimation delay={400}>
                <div className="text-center">
                  <p
                    className="text-xs md:text-[24px] text-[#4A4A48] leading-[2.0] md:leading-[2.2] font-light"
                    style={{ fontFamily: 'Zen Kaku Gothic Soft, sans-serif' }}
                  >
                    自分の幸せを、他人の価値判断で決めない。<br />
                    そんな人が増えたら、<br className="md:hidden" />きっと社会は少しやさしくなる。
                  </p>
                </div>
              </FadeUpAnimation>

              <div className="w-16 h-px bg-[#D7D5D0] mx-auto"></div>

              <FadeUpAnimation delay={600}>
                <div className="text-center">
                  <p
                    className="text-sm md:text-[28px] text-[#A4A4A2] leading-[1.8] md:leading-[2.0] font-medium"
                    style={{ fontFamily: 'Zen Kaku Gothic Soft, sans-serif' }}
                  >
                    to be ——<br />
                    あるべき姿へ。<br />
                    そっと、前へ。
                  </p>
                </div>
              </FadeUpAnimation>
            </div>
          </div>
        </div>
      </section>

      {/* CTAセクション */}
      <section
        className="py-24 bg-[#4A4A48] relative overflow-hidden"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Dark%20water%20surface%20with%20gentle%20ripples%20and%20waves%2C%20deep%20blue-black%20aquatic%20background%20with%20subtle%20light%20reflections%2C%20peaceful%20nighttime%20water%20with%20concentric%20circles%20spreading%20outward%2C%20serene%20and%20contemplative%20atmosphere%2C%20perfect%20for%20dark%20themed%20sections&width=1920&height=1080&seq=home-cta-bg&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="absolute inset-0 bg-[#4A4A48]/85"></div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <FadeUpAnimation delay={800} duration={1400}>
            <a
              href="mailto:tobe26.2b@gmail.com"
              className="inline-flex items-center px-6 py-3 md:px-12 md:py-4 bg-white text-[#4A4A48] rounded-lg hover:bg-[#AFC5C2] hover:text-white transition-all duration-300 text-sm md:text-lg font-medium whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Zen Kaku Gothic Soft, sans-serif' }}
            >
              <i className="ri-mail-line mr-2 md:mr-3 text-lg md:text-xl w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"></i>
              <span className="md:hidden">お問い合わせ</span>
              <span className="hidden md:inline">ご相談・お問い合わせはこちら</span>
            </a>
          </FadeUpAnimation>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
